import { SentenceCase } from "../../utility/helper_functions";
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5";
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage";

const NewmeCsvDownload = ({ trends, loading, tabular }) => {
  const location = window.location.host
  const popupUrl = `${location}/v2-trend`


  const handleDownloadCSV = () => {
    const text = `Trend Name,Demand Forecast,Explanation,Trend Images URL,Newme Image Count,Silhouette Breakdown,Length Breakdown,Neckline Breakdown\n` + (trends.map(trend => {

      const neckShare = trend.secondaryTagsShare && trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['NECKLINE'].includes(t.tag)).length > 0 ? trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['NECKLINE'].includes(t.tag))[0].values : []
      const LengthShare = trend.secondaryTagsShare && trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['BOTTOM LENGTH', 'TOP LENGTH'].includes(t.tag)).length > 0 ? trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['BOTTOM LENGTH', 'TOP LENGTH'].includes(t.tag))[0].values : []

      return `"${trend.value}\ncat :${trend.category}","${trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}%",` +
        `"For next two months, ${trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}% of your ${trend.category} should be ${trend.value} (${SentenceCase(trend.tag)}).",` +
        `"${popupUrl}?trends=both&selectedtag=${trend.tag}&selectedvalue=${trend.value}&gender=${trend.gender}&category=${trend.category}",` +
        `"${trend.newmeretailerCount}",` +
        `"${trend.silhouetteShare ? `${trend.silhouetteShare.map(s => `${s.value} ${Math.round(showFloatToPercentage(s.share, 1))}%`).join(",\n")}` : ""}",` +
        `"${LengthShare.map(s => `${s.value} ${Math.round(showFloatToPercentage(s.share, 1))}%`).join(",\n")}",` +
        `"${neckShare.map(s => `${s.value} ${Math.round(showFloatToPercentage(s.share, 1))}%`).join(",\n")}"`
    })).join('\n')

    let element = document.createElement('a');
    element.setAttribute('href',
      'data:text/plain;charset=utf-8, '
      + encodeURIComponent(text));
    element.setAttribute('download', `news-feed-trends.csv`);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  return tabular ? <button className="bg-slate-600 hover:bg-slate-700 active:bg-slate-800 disabled:bg-slate-400 text-white px-2 py-0.5 mx-1 text-sm rounded" disabled={loading} onClick={handleDownloadCSV}>Export CSV</button> : null
}

export default NewmeCsvDownload;
